/* eslint-disable*/
import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { IoEye, IoEyeOff } from "react-icons/io5";
// import { IoMdArrowDropleft } from "react-icons/io";
import { ImInfo } from "react-icons/im";
import images from "../Resources/Images";
import { validateEmail, logout } from "../Utils/index";
import { getUrl } from "../Network/urls";
import { post } from "../Network/requests";
import Loader from "./UI/Loader";
import { useOutsideClick } from "../Hooks/useOutSideClic";
import PasswordToolTip from "./PasswordToolTip";
import { Button } from '@mui/material';
import PrivacyPolicyDialog from './PrivacyPolicyDialog';
import { Checkbox, FormControlLabel, Link as MuiLink, Typography } from '@mui/material';
import { FormControl, FormHelperText } from '@mui/material';


/* eslint-disable react/jsx-props-no-spreading */

function RegistrationComponent() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [clientidErr, setClientIdErr] = useState("");
  const [fnameErr, setFnameErr] = useState("");
  const [lnameErr, setLnameErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [repasswordErr, setRePasswordErr] = useState("");
  const [otpErr, setOtpErr] = useState("");
  const [clientid, setClientId] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRePassword] = useState("");
  const [sendotp, setSendOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const uppercaseRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const numbersRegex = /[0-9]/;
  const specialCharsRegex = /[@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~!]/;
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
   const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [privacyErr, setPrivacyErr] = useState('');
  const [ppOpen, setPpOpen] = useState(false);
  const privacyRef = useRef(null);


  let operation = "";

  const handleInputChange = (e) => {
    switch (e.target.name) {
      case "email":
        if (e.target.value === "") {
          setEmailErr("Email address is required.");
          setEmail("");
        } else if (!validateEmail(e.target.value)) {
          setEmail(e.target.value);
          setEmailErr("Please enter a valid email address.");
        } else {
          setEmailErr("");
          setEmail(e.target.value);
        }
        break;
      case "clientid":
        if (e.target.value === "") {
          setClientIdErr("Client Id is required.");
          setClientId("");
        } else {
          setClientIdErr("");
          setClientId(e.target.value);
        }
        break;
      case "fname":
        if (e.target.value === "") {
          setFnameErr("First Name is required.");
          setFname("");
        } else {
          setFnameErr("");
          setFname(e.target.value);
        }
        break;
      case "lname":
        if (e.target.value === "") {
          setLnameErr("Last Name is required.");
          setLname("");
        } else {
          setLnameErr("");
          setLname(e.target.value);
        }
        break;
      case "password":
        if (e.target.value === "") {
          setPasswordErr("Password is required.");
          setPassword("");
        } else {
          setPasswordErr("");
          setPassword(e.target.value);
        }
        break;
      case "repassword":
        if (e.target.value === "") {
          setRePasswordErr("Confirm Password is required.");
          setRePassword("");
        } else {
          setRePasswordErr("");
          setRePassword(e.target.value);
        }
        break;
      case "otp":
        if (e.target.value === "") {
          setOtpErr("OTP is required.");
          setOtp("");
        } else {
          setOtpErr("");
          setOtp(e.target.value);
        }
        break;
      default:
        break;
    }
  };

  const handleEnable = () => {
    setIsDisabled(!isDisabled);
  };

  const isOtpValidation = () => {
    let isOtpValid = true;
    if (otp === "") {
      setOtpErr("OTP is required");
      isOtpValid = false;
    }
    return isOtpValid;
  };
  useOutsideClick(containerRef, () => setIsVisible(false));

  const handlePasswordValidation = (pass) => {
    if (!uppercaseRegex.test(pass)) {
      setPasswordErr(
        "The password must contain at least one uppercase letter."
      );
      return false;
    }
    if (!lowercaseRegex.test(pass)) {
      setPasswordErr(
        "The password must contain at least one lowercase letter."
      );
      return false;
    }
    if (!numbersRegex.test(pass)) {
      setPasswordErr("The password must contain at least one number.");
      return false;
    }
    if (!specialCharsRegex.test(pass)) {
      setPasswordErr(
        "The password must contain at least one special character."
      );
      return false;
    }
    if (pass?.length < 12) {
      setPasswordErr("The password must be at least 12 characters long.");
      return false;
    }
    setPasswordErr("");
    return true;
  };
  const isFormValidation = () => {
    let isValid = true;
    if (email === "") {
      setEmailErr("Email address is required.");
      isValid = false;
    }
    if (email !== "" && !validateEmail(email)) {
      setEmailErr("Please enter a valid email address.");
      isValid = false;
    }
    if (clientid === "") {
      setClientIdErr("Client ID is required");
      isValid = false;
    }
    if (fname === "") {
      setFnameErr("First Name is required");
      isValid = false;
    }
    if (lname === "") {
      setLnameErr("Last Name is required");
      isValid = false;
    }
    if (password === "") {
      setPasswordErr("Password is required");
      isValid = false;
    }
    if (repassword === "") {
      setRePasswordErr("Confirm Password is required");
      isValid = false;
    }
    if (repassword !== password) {
      setRePasswordErr("Confirm Password does not match");
      isValid = false;
    }
    if (!handlePasswordValidation(password.trim())) {
      setIsVisible(true); // show password info tooltip
      isValid = false;
    }
    return isValid;
  };

  const handleFormSubmit = (e) => {
    operation = "confirm_user";

    e.preventDefault();
    setSendOtp(true);

    const isOtpValid = isOtpValidation();
    if (isOtpValid) {
      setIsLoading(true);
      const url = getUrl("user-signup");
      const apiPayload = {
        httpMethod: "POST",
        parameters: {
          email: email,
          operation: operation,
          confirm_code: otp,
        },
      };
      const otpData = JSON.stringify(apiPayload);
      post(`${url}`, otpData, false).then((response) => {
        const {
          data: { body, statusCode },
        } = response;
        switch (statusCode) {
          case 200:
            toast.success(body.message);
            setIsLoading(false);
            navigate("/login");

            break;
          case 400:
            setIsLoading(false);
            toast.error(body.message);
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            setIsLoading(false);
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
            break;
        }
      });
    }
  };

  const handleOtpKeyPress = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      handleFormSubmit(event);
    }
  };

  const handleSendOTP = (e) => {
    // get values of all fields in this function
    operation = "signup";
    e.preventDefault();
    setSendOtp(true);

    const isValid = isFormValidation();
    if (isValid) {
      setIsLoading(true);
      const url = getUrl("user-signup");
      const apiPayload = {
        httpMethod: "POST",
        parameters: {
          email: email,
          clientId: clientid,
          userFN: fname,
          userLN: lname,
          password: password,
          operation: operation,
        },
      };
      const registrationData = JSON.stringify(apiPayload);
      post(`${url}`, registrationData, false).then((response) => {
        const {
          data: { body, statusCode },
        } = response;
        switch (statusCode) {
          case 200:
            handleEnable();
            toast.success(body.message);
            setIsLoading(false);
            break;
          case 400:
            setIsLoading(false);
            toast.error(body.message);
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            setIsLoading(false);
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
            break;
        }
      });
    }
  };

  const handleKeyPress = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      handleSendOTP(event);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="registration_wrapper">
        <div style={{ position: "relative", width: "580px" }}>
          <div className="registration_inner" style={{ overflowY: "visible" }}>
            <div className="registration_header">
              <div className="registration_logo">
                <img
                  src={images.Logo}
                  alt="/logo"
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <h5>Register Here For RegData Platform</h5>
            </div>
            <div className="registration_form">
              <form id="form" className="flex flex-col">
                <input
                  type="text"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                  onKeyPress={handleKeyPress}
                />
                {emailErr !== "" ? (
                  <div className="invalid-feedback d-block">{emailErr}</div>
                ) : null}

                <input
                  type="text"
                  placeholder="Client Id"
                  name="clientid"
                  value={clientid}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                  onKeyPress={handleKeyPress}
                />
                {clientidErr !== "" ? (
                  <div className="invalid-feedback d-block">{clientidErr}</div>
                ) : null}

                <input
                  type="text"
                  placeholder="First Name"
                  name="fname"
                  value={fname}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                  onKeyPress={handleKeyPress}
                />
                {fnameErr !== "" ? (
                  <div className="invalid-feedback d-block">{fnameErr}</div>
                ) : null}

                <input
                  type="text"
                  placeholder="Last Name"
                  name="lname"
                  value={lname}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                  onKeyPress={handleKeyPress}
                />
                {lnameErr !== "" ? (
                  <div className="invalid-feedback d-block">{lnameErr}</div>
                ) : null}

                <div className="d-flex position-relative align-items-center registration-input justify-content-between">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={password}
                    className="input-outline-none"
                    onChange={handleInputChange}
                    onBlur={() => {}}
                    onFocus={() => {}}
                  />
                  <div style={{ display: "flex", gap: "17px" }}>
                    {showPassword ? (
                      <IoEye
                        size={20}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    ) : (
                      <IoEyeOff
                        className="cursor-pointer"
                        size={20}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    )}
                    <ImInfo
                      className="cursor-pointer"
                      size={20}
                      onClick={() => setIsVisible(!isVisible)}
                    />
                  </div>
                  {isVisible && <PasswordToolTip containerRef={containerRef} />}
                </div>
                {passwordErr !== "" ? (
                  <div className="invalid-feedback d-block">{passwordErr}</div>
                ) : null}

                <input
                  type="password"
                  placeholder="Confirm Password"
                  name="repassword"
                  value={repassword}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                />
                {repasswordErr !== "" ? (
                  <div className="invalid-feedback d-block">
                    {repasswordErr}
                  </div>
                ) : null}

                {/* Privacy Policy checkbox */}
                <FormControl
                  error={!!privacyErr}
                  component="fieldset"
                  sx={{ width: '100%', m: 0 }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        inputRef={privacyRef}
                        checked={privacyAccepted}
                        onChange={() => {
                          setPrivacyAccepted(!privacyAccepted);
                          if (privacyAccepted) setPrivacyErr('');
                        }}
                        id="privacyPolicy"
                        color="primary"
                      />
                    }
                    label={
                      <Typography variant="body2" component="span">
                        I accept the{' '}
                        <Button
                          variant="text"
                          size="small"
                          onClick={() => setPpOpen(true)}
                          sx={{ padding: 0, textTransform: 'none' }}
                        >
                          Privacy Policy
                        </Button>
                      </Typography>
                    }
                    sx={{ alignItems: 'center' }}
                  />
                    <FormHelperText>{privacyErr}</FormHelperText>
                  </FormControl>

                <PrivacyPolicyDialog
                  open={ppOpen}
                  onClose={() => setPpOpen(false)}
                />
                <button
                  type="button"
                  name="sendotp"
                  value={sendotp}
                  onClick={handleSendOTP}
                  onKeyPress={handleKeyPress}
                >
                  Send OTP
                </button>

                <input
                  type="text"
                  placeholder="Enter OTP"
                  name="otp"
                  value={otp}
                  disabled={isDisabled}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                  onKeyPress={handleOtpKeyPress}
                />
                {otpErr !== "" ? (
                  <div className="invalid-feedback d-block">{otpErr}</div>
                ) : null}

                <button
                  type="button"
                  disabled={isDisabled}
                  onClick={handleFormSubmit}
                >
                  Register
                </button>
                <Link to="/login" onClick={() => logout()}>
                  {" "}
                  Back{" "}
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegistrationComponent;
